import { Component, OnInit, Input, TemplateRef, ViewChild, OnDestroy, OnChanges } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { PHBHPFeaturePackageConfigurationService } from '../ph-bhp-feature-package-configuration.service';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { Ward } from '../Models/Ward';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { AppConfig } from 'src/app/app.config';
import { TranslationKeys } from 'ph-bhp-localization';
import { PHBHPFeaturePackageEvaluationService } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/public_api';
import { PhBhpFeaturePackageSopobservationService } from 'ph-bhp-feature-packages/ph-bhp-feature-package-sopobservation/public_api';

@Component({
  selector: 'lib-ph-bhp-configure-comments',
  templateUrl: './ph-bhp-configure-comments.component.html',
  styleUrls: ['./ph-bhp-configure-comments.component.css']
})
export class PhBhpConfigureCommentsComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  userSubscription: Subscription;
  gridData: any[];
  fields: any[];
  institutionID: number;
  @Input() institutions: any;
  @Input() userData: any;
  itemChange: boolean = false;
  InstitutionsList: [any];
  modalRef: BsModalRef;
  searchText;
  @ViewChild('delmodal') delmodal: TemplateRef<any>;
  @ViewChild('grid') grid: any;
  selectedInstitution
  deleteDataItem
  deleterowIndex
  pageInfo
  selected = 0;
  countryID
  userID
  roleID
  translationKeys: typeof TranslationKeys = TranslationKeys;
  langSubscription: Subscription;

  wardModelGridEdit: any = new UntypedFormGroup({
    commentName: new UntypedFormControl('', Validators.compose([Validators.required, Validators.maxLength(60)])),
    isSOPComment: new UntypedFormControl(true),
    isObserveComment: new UntypedFormControl(true),
  });

  mygroup = new UntypedFormGroup({
    selectedIns: new UntypedFormControl(this.selected)
  });

  fieldsList = {
    commentName: {
      'field': 'commentName',
      'title': 'CONFIGURE.PREDEFINED_COMMENTS',
      editTemplate: {
        type: 'text',
        maxLength: 60,
        isDisabled: (comment: any) => {
          if (this.roleID != 4) {
            return false;
          } else {
            if (comment.roleID == null) return false;
            return comment.roleID != 4;
          }
        }
      }
    },
    sopComment: {
      'field': 'isSOPComment',
      'title': 'CONFIGURE.SOP_COMMENT',
      editTemplate: {
        type: "checkbox",
        textField: "",
        valueField: "isSOPCommentValue",
        isChecked: (comment: any) => {
          var isChecked = false;
          if (!!!comment.packages) isChecked = true;
          else isChecked = comment.packages && comment.packages.includes("1");
          return isChecked;
        },
        isDisabled: (comment: any) => {
          if (this.roleID != 4) {
            return false;
          } else {
            if (comment.roleID == null) return false;
            return !comment.isGlobalSOPComment;
          }
        }
      },
    },
    observeComment: {
      'field': 'isObserveComment',
      'title': 'CONFIGURE.OBSERVE_COMMENT',
      editTemplate: {
        type: "checkbox",
        textField: "",
        valueField: "isObserveCommentValue",
        isChecked: (comment: any) => {
          var isChecked = false;
          if (!!!comment.packages) isChecked = true;
          else isChecked = comment.packages && comment.packages.includes("2");
          return isChecked;
        },
        isDisabled: (comment: any) => {
          if (this.roleID != 4) {
            return false;
          } else {
            if (comment.roleID == null) return false;
            return !comment.isGlobalObserveComment;
          }
        }
      }
    }
  }

  actionItems: any = [
    {
      name: 'CONFIGURE.EDIT',
      imgSrc: 'assets/ph-bhp-layout/svg/icon-edit.svg', 
      isEdit: true,
    },
    {
      name: 'LAYOUT_MODULE.DELETE',
      imgSrc: 'assets/ph-bhp-layout/svg/icon-delete.svg',
      onClick: (dataItem) => { this.openDeleteModal(this.delmodal, dataItem); },
      canDisable: (dataItem) => { return this.roleID != dataItem.roleID; }
    }
  ];

  constructor(
    private service: PHBHPFeaturePackageConfigurationService,
    private evaluationService: PHBHPFeaturePackageEvaluationService,
    private layoutService: PHBHPLayoutPackageService,
    private observationService: PhBhpFeaturePackageSopobservationService,
    private modalService: BsModalService,
    public translate: TranslateService,
    public config: AppConfig
  ) { }

  ngOnInit() {
    this.fields = [];
    this.fields.push(this.fieldsList.commentName);
    this.pageInfo = {
      items: 'CONFIGURE.COMMENTS',
      itemsPerPageLabel: 'CONFIGURE.PER_PAGE.COMMENTS'
    };

    if (this.config.userData) {
      this.onInitInstitution()
    } else {
      this.userSubscription = this.config.userSubject.asObservable().subscribe((res) => {
        this.onInitInstitution()
      });
    }

    this.langSubscription = this.layoutService.lang.asObservable().subscribe((changelang) => {
      this.onInitInstitution();
    })
  }

  onInitInstitution() {
    this.institutions = this.config.institutions;
    this.OnInstitutionsChanges()
    this.onInitCommentsList();

    this.subscription = this.layoutService.institutionIDSubject.asObservable().subscribe((res) => {
      this.onInitCommentsList();
      this.institutionID = this.layoutService.institutionID
      this.onInstitutionChange(this.institutionID);
    });
  }

  onInitCommentsList() {
    this.fields = [];
    this.fields.push(this.fieldsList.commentName);
    var roleId = this.config.userData.roleName.roleId;
    var institutionID = this.layoutService.institutionID
    if (roleId == 1 || roleId == 2 || roleId == 3) {
      institutionID = 0;
      this.fields.push(this.fieldsList.sopComment);
      this.fields.push(this.fieldsList.observeComment);
    }

    this.getCommentsList(institutionID);
  }

  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();

    if (this.userSubscription)
      this.userSubscription.unsubscribe();
  }

  openmodal(template: TemplateRef<any>) {
    this.mygroup.patchValue({
      selectedIns: this.selected
    })
    this.modalRef = this.modalService.show(template, Object.assign({}, {
      class: 'w-420'
    }))
  }

  OnInstitutionsChanges() {
    if (this.institutions && !this.itemChange) {
      this.itemChange = true;
      var roleId = this.config.userData.roleName.roleId
      this.layoutService.showLoader = true;
      this.service.getInstitutionsbyId(this.institutions, roleId).subscribe((res: any) => {
        this.InstitutionsList = res;
        if (this.layoutService.institutionID) {
          this.institutionID = this.layoutService.institutionID;
        } else {
          if (res.length > 0) {
            this.institutionID = res[0].institution.institutionID;
          }
        }
        this.onInstitutionChange(this.institutionID);
        this.layoutService.showLoader = false;
      })
    }

  }

  changeGridLang() {
    this.gridData.forEach((value, index) => {
      this.gridData[index].commentName = value.commentName;
    });
  }
  onInstitutionChange(value) {
    if (this.InstitutionsList && this.InstitutionsList.length > 0) {
      this.getCommentsList(value);
      this.layoutService.institutionID = value;
      this.selected = this.InstitutionsList.find(x => x.institution.institutionID === value).institution.institutionID;
      this.selectedInstitution = this.InstitutionsList.find(x => x.institution.institutionID === value).institution.institutionName;
      var institution = this.InstitutionsList.find(x => x.institution.institutionID === value).institution;
      var roleId = this.config.userData.roleName.roleId;
      this.fields = [];
      this.fields.push(this.fieldsList.commentName);
      if (roleId == 1 || roleId == 2 || roleId == 3) {
        this.fields.push(this.fieldsList.sopComment);
        this.fields.push(this.fieldsList.observeComment);
        return;
      }
      if (this.layoutService.isMyHygieneSOPLicense(institution.packageID) && this.fields.findIndex(x => x.field == 'isSOPComment') == -1) {
        this.fields.push(this.fieldsList.sopComment);
      }

      if (this.layoutService.isObserveLicense(institution.packageID) && this.fields.findIndex(x => x.field == 'isObserveComment') == -1) {
        this.fields.push(this.fieldsList.observeComment);
      }
    }
  }

  getCommentsList(value) {
    var insID = value;
    this.countryID = this.config.userData.country
    this.roleID = this.config.userData.roleName.roleId
    if (this.config.userData.roleName.roleId == 1 || this.config.userData.roleName.roleId == 2) {
      insID = 0;
    }

    if (this.roleID != 4) {
      this.service.getCommentsbyInstitutionId(this.countryID, this.roleID, insID).subscribe((res: any[]) => {
        this.setGridData(res);
      });
    } else {
      this.observationService.getInstitutionGroupIdById(this.layoutService.institutionID).subscribe((groupId) => {
        var institutionGroupId = "0"
        if (groupId != 0) {
          institutionGroupId = `${groupId},${this.layoutService.institutionID}`;
        }
        this.service.getPredefinedCommentsListForIA(this.countryID, institutionGroupId, this.layoutService.institutionID).subscribe((res: any[]) => {
          this.service.getDisabledPredefinedCommentsByIA(insID).subscribe((disabledComments: any[]) => {
            res = res.map(comment => {
              comment.globalPackages = comment.packages;
              if (comment.isDefault) {
                switch (comment.commentName) {
                  case 'jewellery / wrist watch':
                    comment.commentName = this.layoutService.translateText('SOP_OBSERVATION.JEWELLERY_OR_WRIST_WATCH');
                    break;
                  case 'artificial finger nails / nail varnish':
                    comment.commentName = this.layoutService.translateText('SOP_OBSERVATION.ARTIFICIAL_NAILS_OR_VARNISH');
                    break;
                  case 'Hand disinfection executed incorrectly':
                    comment.commentName = this.layoutService.translateText('SOP_OBSERVATION.HAND_DISINFECTION_WRONG_EXECUTED');
                    break;
                  case 'Skin antisepsis executed incorrectly':
                    comment.commentName = this.layoutService.translateText('SOP_OBSERVATION.SKIN_ANTISEPSIS_WRONG_EXECUTED');
                    break;
                  case 'Process interrupted':
                    comment.commentName = this.layoutService.translateText('SOP_OBSERVATION.PROCESS_INTERRUPTED');
                    break;
                }
              }
              var disabledComment = disabledComments.find(x => x.predefinedCommentID == comment.predefinedCommentID);
              if (disabledComment) {
                var packages = [];
                if (!disabledComment.isDisabledSOP) packages.push(1);
                if (!disabledComment.isDisabledObserve) packages.push(2);
                comment.packages = packages.join(',');
              } else {
                if (comment.roleID != 4) {
                  comment.packages = '1,2';
                }
              }

              return comment;
            });
            this.setGridData(res);
          });
        });
      });
    }
  }

  setGridData(res: any[]) {
    for (var i = 0; i < res.length; i++) {
      if (!res[i].packages) {
        res[i].packages = '';
      }

      if (res[i].packages.includes("1")) {
        res[i].isSOPComment = true;
      } else {
        res[i].isSOPComment = false;
      }

      if (res[i].packages.includes("2")) {
        res[i].isObserveComment = true;
      } else {
        res[i].isObserveComment = false;
      }

      if (this.roleID == 4) {
        if (res[i].roleID == 4) {
          res[i].isGlobalSOPComment = true;
          res[i].isGlobalObserveComment = true;
        } else {
          if (res[i].globalPackages.includes("1")) {
            res[i].isGlobalSOPComment = true;
          } else {
            res[i].isGlobalSOPComment = false;
          }

          if (res[i].globalPackages.includes("2")) {
            res[i].isGlobalObserveComment = true;
          } else {
            res[i].isGlobalObserveComment = false;
          }
        }
      }
    }

    if (this.roleID == 4) {
      res = res.filter(comment => comment.isGlobalSOPComment || comment.isGlobalObserveComment);
    }

    let that = this;
    this.gridData = res.map(item => this.manageGrid(item, that));
    this.changeGridLang();
  }

  getPackagesFromComment(comments) {
    var packages = [];
    if (comments.isSOPCommentValue) {
      packages.push(1);
    }
    if (comments.isObserveCommentValue) {
      packages.push(2);
    }
    return packages.join(',');
  }


  handlerData({
    handler,
    formGroup,
    isNew,
    dataItem,
    rowIndex
  }): void {
    this.userData = this.config.userData;
    switch (handler) {
      case 'saveHandler':
        this.roleID == 4 ? this.saveIAHandler(isNew, dataItem, rowIndex) : this.saveHandler(isNew, dataItem, rowIndex);
        break;
      case 'removeHandler':
        break;
    }
  }

  saveHandler(isNew, dataItem, rowIndex) {
    var comments = dataItem;
    comments.userID = this.userData.userId;
    comments.countryID = this.userData.country;
    comments.roleID = this.userData.roleName.roleId
    comments.institutionID = this.layoutService.institutionID
    comments.isGroup = false
    comments.isDeleted = false;
    comments.createdBy = this.userData.userId;
    comments.updatedBy = 0;
    comments.packages = this.getPackagesFromComment(comments);

    if (isNew) {
      comments.isSOPComment = dataItem.isSOPCommentValue;
      comments.isObserveComment = dataItem.isObserveCommentValue;
      this.service.createComments(comments).subscribe((res: any) => {
        // this.layoutService.showSuccess(this.layoutService.translateText('CONFIGURE.MESSAGE_SUCCESSFULLY.ADDED.COMMENT'));
        this.getCommentsList(comments.institutionID);
      });
    } else if (!isNew) {
      comments.updatedBy = this.userData.userId;
      comments.predefinedCommentID = dataItem.predefinedCommentID;
      comments.createdDateTime = dataItem.createdDateTime;
      comments.isSOPComment = dataItem.isSOPCommentValue;
      comments.isObserveComment = dataItem.isObserveCommentValue;
      this.service.updateComments(dataItem.predefinedCommentID, comments).subscribe((res: any) => {
        this.gridData[rowIndex].commentName = comments.commentName;
        var packages = comments.packages;
        if (packages.includes("1")) {
          this.gridData[rowIndex].isSOPComment = true;
        } else {
          this.gridData[rowIndex].isSOPComment = false;
        }
        if (packages.includes("2")) {
          this.gridData[rowIndex].isObserveComment = true;
        } else {
          this.gridData[rowIndex].isObserveComment = false;
        }

        // this.layoutService.showSuccess(this.layoutService.translateText('CONFIGURE.MESSAGE_SUCCESSFULLY.UPDATED.COMMENT'));
        this.getCommentsList(comments.institutionID);
      });

    }
  }

  saveIAHandler(isNew, dataItem, rowIndex) {
    var comments = dataItem;
    if (isNew) {
      comments.userID = this.userData.userId;
      comments.countryID = this.userData.country;
      comments.roleID = this.userData.roleName.roleId
      comments.institutionID = this.layoutService.institutionID
      comments.isGroup = false
      comments.isDeleted = false;
      comments.createdBy = this.userData.userId;
      comments.updatedBy = 0;
      comments.packages = this.getPackagesFromComment(comments);
      comments.isSOPComment = dataItem.isSOPCommentValue;
      comments.isObserveComment = dataItem.isObserveCommentValue;
      this.service.createComments(comments).subscribe((res: any) => {
        this.getCommentsList(comments.institutionID);
      });
    } else if (!isNew) {
      comments.institutionID = this.layoutService.institutionID;
      comments.updatedBy = this.userData.userId;
      comments.predefinedCommentID = dataItem.predefinedCommentID;
      comments.createdDateTime = dataItem.createdDateTime;
      comments.isSOPComment = dataItem.isSOPCommentValue;
      comments.isObserveComment = dataItem.isObserveCommentValue;
      comments.packages = this.getPackagesFromComment(comments);
      if (comments.roleID == 4) {
        this.service.updateComments(dataItem.predefinedCommentID, comments).subscribe((res: any) => {
          this.gridData[rowIndex].commentName = comments.commentName;
          var packages = comments.packages;
          if (packages.includes("1")) {
            this.gridData[rowIndex].isSOPComment = true;
          } else {
            this.gridData[rowIndex].isSOPComment = false;
          }
          if (packages.includes("2")) {
            this.gridData[rowIndex].isObserveComment = true;
          } else {
            this.gridData[rowIndex].isObserveComment = false;
          }

          this.getCommentsList(comments.institutionID);
        });
      } else {
        this.service.updateCommentsAsIA(dataItem.predefinedCommentID, comments).subscribe((res: any) => {
          this.gridData[rowIndex].commentName = comments.commentName;
          var packages = comments.packages;
          if (packages.includes("1")) {
            this.gridData[rowIndex].isSOPComment = true;
          } else {
            this.gridData[rowIndex].isSOPComment = false;
          }
          if (packages.includes("2")) {
            this.gridData[rowIndex].isObserveComment = true;
          } else {
            this.gridData[rowIndex].isObserveComment = false;
          }

          this.getCommentsList(comments.institutionID);
        });
      }

    }
  }

  openDeleteModal(deletemodal: TemplateRef<any>, dataItem) {
    this.deleteDataItem = dataItem
    // this.deleterowIndex = rowIndex
    this.modalRef = this.modalService.show(deletemodal, Object.assign({}, {
      class: 'w-420'
    }))
  }
  delete() {
    this.service.deleteComment(this.deleteDataItem.predefinedCommentID, this.config.userData.userId).subscribe((res: any) => {
      var data: any[] = JSON.parse(JSON.stringify(this.gridData));
      let index = data.findIndex(x => x.predefinedCommentID === this.deleteDataItem.predefinedCommentID);
      data.splice(index, 1);
      this.gridData = data;
    })
  }

  showInstitutionDropDown() {
    if (this.InstitutionsList) {
      if (this.InstitutionsList.length < 2) {
        return false;
      } else {
        return true;
      }
    }
  }
  getInstitutionName() {
    if (this.InstitutionsList && this.InstitutionsList.length > 0) {
      return this.InstitutionsList[0].institution.institutionName;
    }
  }

  manageGrid(item, that) {

    item.isSOPCommentValue = item.isSOPComment;
    item.isObserveCommentValue = item.isObserveComment;

    item.isSOPComment = (item.isSOPComment) ? that.layoutService.translateText('CONFIGURE.ENABLED') : that.layoutService.translateText('CONFIGURE.DISABLED');
    item.isObserveComment = (item.isObserveComment) ? that.layoutService.translateText('CONFIGURE.ENABLED') : that.layoutService.translateText('CONFIGURE.DISABLED');

    if (that.roleID == 4) {
      item.isSOPComment = (item.isGlobalSOPComment) ? item.isSOPComment : that.layoutService.translateText('CONFIGURE.DISABLED');
      item.isObserveComment = (item.isGlobalObserveComment) ? item.isObserveComment : that.layoutService.translateText('CONFIGURE.DISABLED');
    }

    return item;
  }

  addNew() {
    if (!this.grid.isNew) {
      this.gridData.unshift({
        commentName: '',
        isSOPComment: true,
        isObserveComment: true,
        isSOPCommentValue: true,
        isObserveCommentValue: true,
        packages: "1,2"
      });
      this.grid.editRowIndex = 0;
      this.grid.editItem = {};
      this.grid.isNew = true;
      this.grid.changeValue(true, 0, 'isSOPComment', 'check');
      this.grid.changeValue(true, 0, 'isObserveComment', 'check');
      this.grid.changeValue(true, 0, 'isSOPCommentValue', 'check');
      this.grid.changeValue(true, 0, 'isObserveCommentValue', 'check');
      this.grid.updateGrid();
    }
  }
}
